<template>
<!-- 用于单行, 字数过多出现...时自动增加el-tooltip, 字数不多则不显示 -->
  <el-tooltip
    v-showtip
    :content="content"
    :placement="placement">
    <span class="value oneline">
      <span class="ellipse-text" :class="className"><span v-if="title">{{title}}</span>{{ content || '- -' }}</span>
    </span>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    placement: {
      default: 'top-start'
    },
    title: { // 是否有标题
      default: ''
    },
    content: { // 主要文字
      default: ''
    },
    className: {
      default: ''
    }
  },
  created () {
    // console.log(this.title, this.content)
  }
}
</script>

<style lang="scss" scoped>
.value {
   flex: 1; // 核心 上级元素flex布局，flex1后可获取真实宽度判断
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
 }
 .ellipse-text{} // 目前什么内容都没有，方便标识而已
</style>
